import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from './redux/store'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Views from './views'

import { ThemeSwitcherProvider } from 'react-css-theme-switcher'
import { THEME_CONFIG } from './configs/AppConfig'
import { GoogleOAuthProvider } from '@react-oauth/google'
// import { Toaster } from "react-hot-toast";
import ReactGA from 'react-ga4'
import MixpanelProvider from 'configs/mixPanelProvider'

// Initialize Google Analytics only if GA ID exists
if (process.env.REACT_APP_GA_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_ID)
  
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
  })
} else {
  console.log('Google Analytics ID not found. Skipping GA initialization.')
}

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}

// TrackingMiddleware to capture route changes
function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="App">
        {/* <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "1.5rem",
          },
        }}
      /> */}
        <Provider store={store}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Router basename="/">
              <MixpanelProvider>
                <Switch>
                  <Route path="/" component={Views} />
                </Switch>
              </MixpanelProvider>
            </Router>
          </ThemeSwitcherProvider>
        </Provider>
      </div>
    </GoogleOAuthProvider>
  )
}

export default App